// extracted by mini-css-extract-plugin
export default {"filterPanel":"PowerBIReportFilterPanel_filterPanel__mmJnk"};